import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { supportCenterApi } from "./api";
import { AddHelpfullPayload } from "./types";

export const useServiceDetail = (params: {
  remote_utility_id: string;
  consumer_id: string;
  search_data?: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.contacts.cotactDetail(params),
    () => supportCenterApi.getServiceDetail(params)
  );
};

export const useFaqData = (params: {
  remote_utility_id: string;
  show_inactive: any;
  faq_category: string;
}) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.faqs.faqData(params),
    () => supportCenterApi.getFaq(params)
  );
};

export const useFaqSearch = (params: {
  search_data: string;
  remote_utility_id: string;  
}, options?: { enabled?: boolean }) => {
  return useSmartQuery(
    QueryKeyFactory.module.cx.faqs.searchFaq(params),
    () => supportCenterApi.searchFaq(params),
    {
      enabled: options?.enabled !== false && params.search_data.length > 0,
      staleTime: 30000,
    }
  );
};

export const useUpdateFaqStatus = () => {
  return useSmartMutation(
    (payload: AddHelpfullPayload) =>
      supportCenterApi.addHelpful(payload)
  );
};
